
const initialState = {
  loading: false,
  newPass: false,
  error: false,
  gdprListing: [],
  gdprDetail: null
};

const gdprReducer = (state = initialState, action) => {
  // console.log("gdpr  reducers------", state, action);
  switch (action.type) {
    case "ADD_GDPR_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "ADD_GDPR_SUCCESS":
      return {
        ...state,
        loading: false,
        newPass: true,
        error: false,
      };
    case "ADD_GDPR_FAILED":
      return {
        ...state,
        loading: false,
        newPass: false,
        error: true,
      };

    case "GET_GDPR_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_GDPR_REQUEST_FAILED":
      return {
        ...state,
        error: true,
      };
    case "GET_GDPR_REQUEST_SUCCESS":
      return {
        ...state,
        gdprListing: action.payload,
        loading: false,
      };


    case "GOT_GDPR_DETAIL":
      return {
        ...state,
        gdprDetail: action.payload,
      };
    default:
      return state;
  }
};

export default gdprReducer;
